export default __webpack_public_path__ + "static/media/KZ.T.20.0758.193a3d96.svg";